import { GetEmdPassengerReceiptResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetEmdPassengerReceiptModel } from './get-emd-passenger-receipt.state';

/** StateDetailsActions */
const ACTION_SET = '[GetEmdPassengerReceipt] set';
const ACTION_UPDATE = '[GetEmdPassengerReceipt] update';
const ACTION_RESET = '[GetEmdPassengerReceipt] reset';
const ACTION_FAIL = '[GetEmdPassengerReceipt] fail';
const ACTION_CANCEL_REQUEST = '[GetEmdPassengerReceipt] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetEmdPassengerReceipt] set from api';
const ACTION_UPDATE_FROM_API = '[GetEmdPassengerReceipt] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetEmdPassengerReceipt = createAction(ACTION_SET, props<WithRequestId<GetEmdPassengerReceiptModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetEmdPassengerReceipt = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetEmdPassengerReceiptModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetEmdPassengerReceipt = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetEmdPassengerReceiptRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetEmdPassengerReceipt = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetEmdPassengerReceiptFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetEmdPassengerReceiptResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetEmdPassengerReceiptFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetEmdPassengerReceiptResponse>>()
);
